import { useQuery } from '@tanstack/react-query';
import { organizationRoleApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useRoles() {
  return useQuery({
    queryKey: queryKeys.organization.roles(),
    queryFn: ({ signal }) =>
      organizationRoleApiClient.list(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'organization roles',
    },
  });
}
